var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeonatal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    id: "svg27",
    width: 26,
    height: 26,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs7"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style1"
  }, "\n      .cls-neonatal2 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Neonatal",
    transform: "translate(-32,-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g24"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-neonatal2",
    cx: 40.240002,
    cy: 10.55,
    rx: 4.2399998,
    ry: 4.1500001,
    id: "ellipse22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-neonatal2",
    d: "m 37.86,14.55 c -3.22,1.87 -1.53,7.09 2.17,9.91 2.88,2.19 7.23,2.66 9.77,0.72",
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-neonatal2",
    d: "m 50.6,20.28 c 0,0 0.26,1.82 0.23,2.09 -0.1,1.07 -0.18,1.28 -0.63,2.28 -0.1,0.23 -0.23,0.37 -0.25,0.38 0.23,0.12 0.29,0.1 0.54,0.1 1.38,0 2.65,-1.75 2.49,-4.21 -0.19,-2.92 -1.12,-4.21 -2.49,-4.21 -1.05,0 -2.65,1.54 -3.09,4.85",
    id: "path23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-neonatal2",
    d: "m 41.54,14.79 3.68,1.65 2.46,-0.75 c 0.56,-0.25 1.23,0 1.49,0.54 v 0 c 0.26,0.55 0,1.2 -0.56,1.46 l -3.14,1.38 -4.54,-1.28",
    id: "path24"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-neonatal2",
    cx: 45.450001,
    cy: 14.76,
    rx: 1.15,
    ry: 1.12,
    id: "ellipse24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g27"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-neonatal8",
    clipPath: "url(#clippath-neonatal-5)",
    id: "g25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-neonatal2",
    d: "m 50.69,6.84 c -0.06,0.43 -0.21,0.85 -0.44,1.22 -0.09,0.15 -0.2,0.29 -0.31,0.43 -0.12,0.16 -0.24,0.32 -0.37,0.48 -0.27,0.35 -0.54,0.7 -0.75,1.09 -0.21,0.39 -0.36,0.82 -0.36,1.27 0,1.84 1.76,2.4 2.59,2.26",
    id: "path25"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-neonatal3",
    clipPath: "url(#clippath-neonatal-6)",
    id: "g26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-neonatal2",
    d: "m 50.8,6.84 c 0.06,0.43 0.21,0.85 0.44,1.22 0.09,0.15 0.2,0.29 0.31,0.43 0.12,0.16 0.24,0.32 0.37,0.48 0.27,0.35 0.54,0.7 0.75,1.09 0.21,0.39 0.36,0.82 0.36,1.27 0,1.84 -1.76,2.4 -2.59,2.26",
    id: "path26"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeonatal);
export default __webpack_public_path__ + "static/media/Neonatal.dd27b8e3338f26ffe3f5bf5cf0d973d1.svg";
export { ForwardRef as ReactComponent };